import { Link } from "@fluentui/react";
import { LinkRegular } from "@fluentui/react-icons";
import {
  GridColDef,
  GridRowSelectionModel
} from "@mui/x-data-grid";
import React from "react";
import { formatDate } from "../../../../helper/DateFormat";
import { DATA_GRID_CONFIG } from "../../../../SharedComponents/Constants/CustomCustomerList.constants";
import { CustomDataGrid } from "../../../../SharedComponents/CustomDataGrid/CustomDataGrid";
import { handleToggleDataGridRowSelection } from "../../../../Utils/js-common";

const COSOCTable = (props: any) => {
  const [selectionModel, setSelectionModel] = React.useState<GridRowSelectionModel>([]);
  const handleSelection = handleToggleDataGridRowSelection(selectionModel, setSelectionModel);
  const [paginationOptions, setPaginationOptions] = React.useState(DATA_GRID_CONFIG.pagination);

  const showNoData = () => {
    const rootStyle = {
      alignItems: "center",
      display: "flex",
      fontSize: 18,
      fontWeight: 600,
      justifyContent: "center",
      padding: 200
    };
    return <div style={rootStyle}>{`COSOC Community details coming soon for ${props.productName}.`} </div>;
  };
  const yesNoFormatter = (params: { value?: number | string }) => {
    if (params?.value === 1 || params?.value === "1") return "Yes";
    if (params?.value === 0 || params?.value === "0") return "No";
    return ""; // or "N/A" if you prefer
  };
  const columns: GridColDef[] = [
    {
      headerName: "Question Link",
      field: "questionLink",
      width: 120,
      sortable: false,
      renderCell: (params) => (
        <div
          style={{
            width: "100%",
            height: "100%",
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <Link
            href={params.row.questionLink}
            title={params.row.questionLink}
            target="_blank"
            rel="noopener noreferrer"
            tabIndex={params.row.tabIndex}
            style={{
              color: "rgb(0, 120, 212)",
              textDecoration: "none",
              fontSize: 26,
              cursor: "pointer"
            }}
          >
            <LinkRegular />
          </Link>
        </div>
      )
    },
    { headerName: "WorkItem ID", minWidth: 100, field: "workItemId", sortable: true, flex: 1 },
    { headerName: "Title", field: "title", minWidth: 300, sortable: true, flex: 1 },
    { headerName: "State", minWidth: 150, field: "state", sortable: true, flex: 1 },
    { headerName: "Source", minWidth: 150, field: "stackOverflowSource", sortable: true, flex: 1 },
    { headerName: "Assigned To", minWidth: 150, field: "assignedToDisplayName", sortable: true, flex: 1 },
    {
      headerName: "Question Date",
      minWidth: 150,
      field: "stackOverflow_QuestionDate",
      sortable: true,
      flex: 1,
      valueGetter: (value, row) => new Date(row.stackOverflow_QuestionDate),
      renderCell: (params) => formatDate(params.row.stackOverflow_QuestionDate)
    },
    {
      headerName: "Questions Answered",
      minWidth: 100,
      field: "questionsAnswered",
      sortable: true,
      flex: 1,
      renderCell: yesNoFormatter
    },
    {
      headerName: "Verified Answer",
      minWidth: 100,
      field: "verifiedAnswer",
      sortable: true,
      flex: 1,
      renderCell: yesNoFormatter
    },
    { headerName: "SLA Met", minWidth: 100, field: "slaMet", sortable: true, flex: 1, renderCell: yesNoFormatter }
  ];

  React.useEffect(() => {
    setTimeout(() => {
      const elements = document.getElementsByClassName("MuiDataGrid-virtualScroller");
      Array.from(elements).forEach(function (element) {
        element.setAttribute("tabIndex", "0");
      });
    }, 1000);
  }, []);

  return (
    <>
      {props.tableData && props.tableData.length > 0 ? (
        <div style={{ height: 600, marginLeft: 8, marginRight: 8, overflow: "auto" }}>
          <CustomDataGrid
            columns={columns}
            getRowId={props.getRowId ?? (() => crypto.randomUUID())}
            rows={{ values: props.tableData ?? [], count: props.tableData?.length ?? 0 }}
            slotProps={{ toolbar: { showQuickFilter: true } }}
            paginationOptions={paginationOptions}
            setPaginationOptions={setPaginationOptions}
            onRowSelectionModelChange={handleSelection}
            rowSelectionModel={selectionModel}
            kustoLink={props.kustoLink}
            initialState={{
              sorting: {
                sortModel: [{ field: "stackOverflow_QuestionDate", sort: "desc"  }] // Default sorting by stackOverflow_QuestionDate in descending order
              }
            }}
          />
        </div>
      ) : (
        showNoData() || ""
      )}
    </>
  );
};

export default COSOCTable;
